/* eslint-disable */

import axios from "axios";
import { make } from "vuex-pathify";
import UnitService from "@/service/unit.service";

const url = require("../../client_config/config").url;

const state = {
  shiftDrawer: null,
  calendarType: "week",
  csvDialog: null,
  bulkPublishDialog: null,
  bulkDeleteDialog: null,
  copyScheduleDialog: null,
  addTimeClockDialog: null,
  houseDialog: null,
  staffDialog: null,
  clientDialog: null,
  addShiftDialog: null,
  viewTotalTimeDialog: null,
  isFormDialogOpen: false,
  userRole: localStorage.getItem("userRole"),
  selectedShift: {},
  clientsFilter: [],
  staffFilter: [],
  unitIdsFilter: [],
  startDateFilter: "",
  endDateFilter: "",
};

const getters = {};

const actions = {
  async downloadCSV({ commit }, data) {
    try {
      const response = await axios.post(`${url}/shifts/csv/`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getBulkPublish({ commit }, data) {
    try {
      const response = await axios.post(`${url}/shifts/getBulkPublish/`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async doBulkPublish({ commit }, data) {
    try {
      const response = await axios.post(`${url}/shifts/bulkPublish/`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getBulkDelete({ commit }, data) {
    try {
      const response = await axios.post(`${url}/shifts/getBulkDelete/`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async doBulkDelete({ commit }, data) {
    try {
      const response = await axios.post(`${url}/shifts/bulkDelete/`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async getSchedule({ commit }, data) {
    try {
      const response = await axios.post(`${url}/shifts/getSchedule/`, data);
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },

  async saveCopySchedule({ commit }, data) {
    console.log(data);
    try {
      const response = await axios.post(
        `${url}/shifts/saveCopySchedule/`,
        data
      );
      return response;
    } catch (error) {
      console.log(error);
      return error.response;
    }
  },
};

const mutations = {
  ...make.mutations(state),

  SET_SHIFT_DRAWER(state, data) {
    state.shiftDrawer = data;
  },

  SET_SHIFT_CALENDAR_TYPE(state, data) {
    state.calendarType = data;
  },

  SET_CSV_DIALOG(state, data) {
    state.csvDialog = data;
  },

  SET_BULK_PUBLISH_DIALOG(state, data) {
    state.bulkPublishDialog = data;
  },

  SET_BULK_DELETE_DIALOG(state, data) {
    state.bulkDeleteDialog = data;
  },

  SET_COPY_SCHEDULE_DIALOG(state, data) {
    state.copyScheduleDialog = data;
  },

  SET_ADD_TIME_CLOCK_DIALOG(state, data) {
    state.addTimeClockDialog = data;
  },

  SET_HOUSE_DIALOG(state, data) {
    state.houseDialog = data;
  },

  SET_STAFF_DIALOG(state, data) {
    state.staffDialog = data;
  },

  SET_CLIENT_DIALOG(state, data) {
    state.clientDialog = data;
  },

  SET_ADD_SHIFT_DIALOG(state, data) {
    state.addShiftDialog = data;
  },

  SET_VIEW_TOTAL_TIME_DIALOG(state, data) {
    state.viewTotalTimeDialog = data;
  },

  SET_FORM_DIALOG_isOPEN(state, data) {
    state.isFormDialogOpen = data;
  },

  SET_SELECTED_SHIFT(state, data) {
    state.selectedShift = data;
  },

  SET_STAFF_FILTER(state, data) {
    state.staffFilter = data;
  },

  SET_CLIENTS_FILTER(state, data) {
    state.clientsFilter = data;
  },

  SET_UNITIDS_FILTER(state, data) {
    state.unitIdsFilter = data;
  },

  SET_STARTDATE_FILTER(state, data) {
    state.startDateFilter = data;
  },

  SET_ENDDATE_FILTER(state, data) {
    state.endDateFilter = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
